import { Component } from '@angular/core';
import { default as getTenantConfig, OptionalValmetDnaConfiguredTag, ValmetDnaTagConfig } from '~app/shared/map/layer/layer-definitions/T14';

@Component({
  selector: 'qm-neve-measurements',
  templateUrl: './neve-measurements.component.html',
  //styleUrls: ['./neve-measurements.component.scss']
})
export class NeveMeasurementsComponent {
  public mainNetworkTags: ValmetDnaTagConfig[];
  public auxiliaryNetworkTags: ValmetDnaTagConfig[];
  public pressureAndTemperatureConfig: {
    columns: {
      name: string,
      valmetDnaTags: OptionalValmetDnaConfiguredTag[],
    }[],
    groupNames: string[]
  };

  constructor() {
    const { valmetDnaTags } = getTenantConfig().tenantCustomData;
    const { mainNetwork, auxiliaryNetwork } = valmetDnaTags.power;

    this.mainNetworkTags = mainNetwork;
    this.auxiliaryNetworkTags = auxiliaryNetwork;

    // TODO: i18n
    this.pressureAndTemperatureConfig = {
      columns: [{
        name: 'Paine-ero',
        valmetDnaTags: valmetDnaTags.pressure.delta
      }, {
        name: 'Menopaine',
        valmetDnaTags: valmetDnaTags.pressure.out,
      }, {
        name: 'Paluupaine',
        valmetDnaTags: valmetDnaTags.pressure.return,
      }, {
        name: 'Menolämpö',
        valmetDnaTags: valmetDnaTags.temperature.out,
      }, {
        name: 'Paluulämpö',
        valmetDnaTags: valmetDnaTags.temperature.return,
      }],
      groupNames: [
        'Suosiola',
        'Rantavitikka',
        'Ennen apujäähdyttimen pumppua',
        'Apujäähdyttimen pumpun jälkeen',
        'Ounasvaara',
        'Rekimatka',
        'Kiveliöntie',
        'Jätkänkynttilä',
        'Lentokenttä',
        'Santapark',
        'Nivavaara',
        'Norvatien laitos ennen pumppaamoa',
        'Kaamoskuja',
        'Suutarinkorva',
        'Someroharju',
        'Maunun Matti',
        'Napapiiri',
        'Norvatie',
        'Hilleritie'
      ]
    };
  }
}
